<div class="modal-header">
    <h6 class="modal-title pull-left"> User Details</h6>
    <button type="button" class="close btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <section class="content">
        <div class="container-fluid">
            <div class="box">
                <div class="box-body table-responsive">
                    <table id="example1" class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>Gate Name</th>
                                <th>Log Date Time</th>
                                <th>Dining</th>
                                <th>Approve Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of userList  let i = index">
                                <td>{{ item.gate_name}}</td>
                                <td>{{ item.created_at | date :"yyyy/MM/dd"}} at {{(item.created_at | date :"HH:mm")
                                    }}{{(item.created_at | date :"HH")>11?' PM':' AM' }}</td>
                                <td>{{
                                    item.dining_status==1?'Breakfast':item.dining_status==2?"Lunch":item.dining_status==3?"Conversations
                                    Over Kahwa":item.dining_status==4?"Dinner":''}}</td>
                                <td><span [ngClass]="item.approved_status==1?'approved btn-success':'rejected'"
                                        class="open">{{ item.approved_status==1?'Approved':"Declined"}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</div>